// Declared twice so that docs appear when selecting colors
export interface PrismPalette extends Record<string, string> {
  /** **#E0F4F0** Cyan */
  readonly prism10: string;
  /** **#C3EAE7** Cyan */
  readonly prism30: string;
  /** **#8EDDD4** Cyan */
  readonly prism60: string;
  /** **#36BCA2** Cyan */
  readonly prismPrimary: string;
  /** **#1A9F90** Cyan */
  readonly prism80: string;
  /** **#09786C** Cyan */
  readonly prism90: string;
}

export const prismPalette: PrismPalette = {
  prism10: '#E0F4F0',
  prism30: '#C3EAE7',
  prism60: '#8EDDD4',
  prismPrimary: '#36BCA2',
  prism80: '#1A9F90',
  prism90: '#09786C',
};
